import React from 'react';
import { isNumberControl, RankedTester, rankWith } from '@jsonforms/core';
import { MantineInputNumber } from '../mantine-controls/MantineInputNumber';
import { MantineInputControl } from './MantineInputControl';
import { ControlProps } from '../../types/controlProps';
import { withJsonFormsControlProps } from '../utils/withJsonFormsPropsMappers';

export const MantineNumberControl = (props: ControlProps) => (
  <MantineInputControl {...props} input={MantineInputNumber} />
);

export const mantineNumberControlTester: RankedTester = rankWith(2, isNumberControl);

export default withJsonFormsControlProps(MantineNumberControl);
